import { Button as ButtonV2 } from "../Button";
import { ErrorIconV2 } from "../Icons";
import { Typo } from "../Typo";
import type { MarketingBannersTranslations } from "./types";

/**
 * Error state for the marketing-banners table and banner library.
 * Strings come either from explicit `title`/`subtitle`/`buttonLabel` props or
 * fall back to the `translations` object.
 */
export const MarketingBannersErrorDisplay = ({
  onRefresh,
  translations,
  title,
  subtitle,
  buttonLabel,
}: {
  onRefresh: () => void;
  translations?: MarketingBannersTranslations;
  title?: string;
  subtitle?: string;
  buttonLabel?: string;
}) => {
  const resolvedTitle = title ?? translations?.states.error.title ?? "";
  const resolvedSubtitle =
    subtitle ?? translations?.states.error.subtitle ?? "";
  const resolvedButton =
    buttonLabel ?? translations?.states.error.refreshButton ?? "Refresh";

  return (
    <div className="flex h-[384px] flex-col items-center justify-center gap-6">
      <ErrorIconV2 height={64} width={64} />
      <div className="flex flex-col items-center gap-4">
        <Typo type="labelLG" smType="labelMD">
          {resolvedTitle}
        </Typo>
        <Typo type="bodyMD" smType="bodySM" textColor="text-text-secondary">
          {resolvedSubtitle}
        </Typo>
      </div>
      <ButtonV2 onClick={onRefresh}>{resolvedButton}</ButtonV2>
    </div>
  );
};
